import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import Dropdown, { Option } from '../common/dropdown'
import { ReactElement } from 'react'

type ControlledDropdownProps<IFormValues extends FieldValues> = {
    options: Option[]
    label?: string
    required?: boolean
    placeholder?: string
    name: Path<IFormValues>
    control: Control<IFormValues, any>
    disabled?: boolean
    unit?: string
    className?: string
    searchable?: boolean
    renderOption?: (option: Option) => ReactElement
    hideLabel?: boolean
    onSearchTermChange?: (value: string) => void
    onChange?: (value: Option['id']) => void
    onOptionNotFound?: (searchTerm: string) => void
    onEndReached?: () => void
    info?: string
}

const ControlledDropdown = <IFormValues extends FieldValues>({
    control,
    name,
    label,
    options,
    required,
    placeholder,
    disabled,
    unit,
    searchable,
    className,
    hideLabel,
    renderOption,
    onSearchTermChange,
    onChange,
    onEndReached,
    onOptionNotFound,
    info,
}: ControlledDropdownProps<IFormValues>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <Dropdown
                    options={options}
                    hideLabel={hideLabel}
                    label={label}
                    info={info}
                    searchable={searchable}
                    value={field.value}
                    error={fieldState.error?.message as any}
                    onChange={(value) => {
                        field.onChange(value as any)
                        onChange && onChange(value)
                    }}
                    required={required}
                    disabled={disabled}
                    placeholder={placeholder}
                    unit={unit as string}
                    className={className}
                    renderOption={renderOption}
                    onSearchTermChange={onSearchTermChange}
                    onOptionNotFound={onOptionNotFound}
                    onEndReached={onEndReached}
                />
            )}
        />
    )
}

export default ControlledDropdown
